<template>
  <el-main>
    <guides />
  </el-main>
</template>

<script>
  // components
  import Guides from './guides/Guides.vue';

  export default {
    name: 'PageContent',
    components: {
      Guides
    },
  }
</script>
